import React, { useState } from "react";
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
} from "@mui/icons-material";

function About() {
  const [showInfo1, setShowInfo1] = useState(false);
  const [showInfo2, setShowInfo2] = useState(false);

  const handleButtonClick1 = () => {
    setShowInfo1(!showInfo1);
    setShowInfo2(false); // Close the other button
  };

  const handleButtonClick2 = () => {
    setShowInfo2(!showInfo2);
    setShowInfo1(false); // Close the other button
  };

  return (
    <div className="h-full rounded-xl mt-20 p-8 bg-white lg:w-11/12 mx-auto flex flex-col justify-between shadow-md">
      <div className="mb-4">
        <h2 className="text-2xl font-bold">Asaxiy kompaniyasi haqida</h2>
      </div>
      <div className="mb-4 normalFont">
        <p className="text-base sm:text-xl">
          Butun O‘zbekiston bo‘ylab maishiy texnika va elektronika tovarlarini
          yetkazib beruvchi kompaniyamizning asosiy afzalligi – ko‘p yillik ish
          tajribasi va yaxshi nom qozonib ulgurganidir. Asos solinganidan buyon
          Asaxiy internet-do‘koni va uning jamoasi iste’mol bozorining talablari
          tendensiyalarini tinimsiz kuzatib kelmoqda; bu esa bizga eng so‘nggi
          texnologiyalar va innovatsion yechimlardan hamisha boxabar bo‘lib
          turish imkonini beradi.
        </p>
      </div>

      <div className="mb-4 normalFont">
        <p className="text-base sm:text-xl">
          Kompaniiya mutaxassislari mijozlarimizning istaklarini diqqat bilan
          o‘rganishadi, shu bois resurs doimiy tarzda hamyonbop narxlardagi
          sifatli yangi mahsulotlar bilan boyitilib kelmoqda.
        </p>
      </div>

      <div className="m-3 p-2 normalFont flex flex-col border rounded-xl">
        <button
          className={`bg-white text-left p-1 text-gray-500 border-b font-medium py-2 rounded-tl-xl rounded-tr-xl flex items-center justify-between transition-all duration-500 ease-in ${
            showInfo1 ? "pb-2" : "pb-1"
          }`}
          onClick={handleButtonClick1}
        >
          Kompaniya ish tamoyili
          {showInfo1 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </button>
        {showInfo1 && (
          <div className="p-6">
            <p className="text-base sm:text-xl mb-2">
              Har bir xaridor{" "}
              <a className="text-blueColor underline" href="#">
                telefonlar va boshqa gadjetlar
              </a>
              ni qulay shart-sharoitlarda, maksimal darajada tez tanlay olishi
              kerak; shuning uchun biz intuitiv tushunarli menyu yaratganmiz,
              internetning yangi foydalanuvchilari ham uni o‘zlashtirib
              olishlari oson. Juda qulay bo‘lishini ko‘zlab biz menyu qismini
              tegishli bo‘limlarga ajratganmiz, ularda siz 15 ming xildan ortiq
              orgtexnika va unga yondosh tovarlarni topishingiz mumkin. Ular
              quyidagicha ko‘rinish olgan:
            </p>

            <ul className="list-disc">
              <li className="text-base sm:text-xl mb-2">
                <a className="text-blueColor underline" href="#">
                  Idish-tovoqlar -
                </a>{" "}
                bu yerda siz kundalik turmushimizda ishlatiladigan turli-tuman
                uy-ro‘zg‘or buyumlarining eng keraklilarini topasiz. Do‘konimiz
                saytida taqdim etilgan tovarlar yuqori sifatga va mustahkamlikka
                ega;
              </li>

              <li className="text-base sm:text-xl mb-2">
                <a className="text-blueColor underline" href="#">
                  Konditsionerlar -
                </a>
                va uy iqlimi texnikasi – bu bo‘lim o‘z ehtiyojlaringizga mos
                tarzda foydali xaridlar qilishingizda ko‘maklashadi. Har bir
                tovarning tavsifi berilgan, bu esa to‘g‘ri tanlash imkonini
                beradi;
              </li>
              <li className="text-base sm:text-xl mb-2">
                <a className="text-blueColor underline" href="#">
                  Televizor, video va audio -{" "}
                </a>
                tovarlari navbatdagi bo‘limda joylashgan, bu bo‘lim maishiy
                texnika mahsulotlari nomiga munosib. Bu yerda zamon bilan
                hamqadam tarzdagi funksiyalarning to‘laqonli ro‘yxatiga ega
                bo‘lgan eng so‘nggi yangi mahsulotlar va ishlanmalar o‘rin
                olgan;
              </li>
              <li className="text-base sm:text-xl mb-2">
                <a className="text-blueColor underline" href="#">
                  Go'zallik va salomatlik uchun texnika
                </a>
                doimiy xaridorlarimiz bo‘lmish ayol-qizlarga eng sevimli
                bo‘limlardan biri. Zero, ular salomatlikning qadriga yetishadi
                va to‘g‘ri ovqatlanish yo‘li bilan tabiiy go‘zallikka
                intilishadi
              </li>
              <li className="text-base sm:text-xl mb-2">
                <a className="text-blueColor underline" href="#">
                  Kompyuter va orgtexnika
                </a>
                eng katta bo‘lim, chunki u kompyuterlashtirish jarayonini
                osonlashtirishga va ish vaqti sarfini kamaytirishga
                mo‘ljallangan barcha turdagi aksessuarlar hamda yordamchi
                butlovchi qismlarni ham o‘z ichiga olgan.
              </li>
            </ul>

            <p className="text-base sm:text-xl mb-2">
              Shuningdek, Asaxiy.uz kompaniyamiz o‘yin servislari ishqibozlari
              haqida ham qayg‘uradi,{" "}
              <a className="underline text-blueColor" href="#">
                geymerlar
              </a>{" "}
              uchun bo‘limi buning yaqqol dalilidir. Bu yerda qudratli kompyuter
              ta’minoti mahsulotlari, o‘yinbop sichqoncha va klaviaturalar
              taqdim etilgan; ular o‘yin jarayonini maksimal darajada aniq va
              bexato amalga oshirishga imkon beradi.
            </p>

            <p className="text-base sm:text-xl mb-2">
              Mutolaa ixlosmandlari uchun esa biz audio{" "}
              <a href="#" className="mb-4 underline text-blueColor">
                kitoblar
              </a>{" "}
              ko‘rinishida takomillashtirilgan adabiyot namunalarini taqdim
              etmoqdamiz; ularning janr va mavzulari yetarlicha keng ko‘lamli.
            </p>
          </div>
        )}
        <button
          className={`bg-white text-left p-1 text-gray-500 font-medium py-2 rounded-tl-xl rounded-tr-xl flex items-center justify-between transition-all duration-200 ease-in ${
            showInfo2 ? "pb-2" : "pb-1"
          }`}
          onClick={handleButtonClick2}
        >
          Biznig afzalliklarimiz
          {showInfo2 ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </button>
        {showInfo2 && (
          <div className="p-4">
            <p className="text-base sm:text-xl mb-4">
              Asaxiy.uz kompaniyasi o‘zining barcha imkoniyatlarini shiddat
              bilan kengaytirmoqda, bugun biz o‘z mijozlarimizga ancha-muncha
              <a href="#" className="underline text-blueColor">
                chegirmalarni
              </a>{" "}
              va bir qator shaharlarga tezkor yetkazib berishni taklif
              etmoqdamiz. Bizning yetkazib berish hududlarimiz bilan batafsil
              tanishish uchun internet-do‘konimiz mutaxassisiga qo‘ng‘iroq
              qilishingiz mumkin, u sizni qiziqtiruvchi barcha ma’lumotlarni
              taqdim etadi.
            </p>

            <p className="text-base sm:text-xl">
              Do‘konimizning har bir xaridori – hurmatli mehmonimizdir, unga biz
              yoqimli chegirmalar va bonus dasturlarini taklif etamiz. Biz mijoz
              talablariga mos tovarlarni tanlash jarayonida unga to‘liq
              hamrohlik qilamiz va istalgan qulay usul bilan yetkazib berishni
              amalga oshiramiz.
            </p>
          </div>
        )}
      </div>

      <div>
        <div className="text-lg sm:text-xl font-medium mb-2">
          "Asaxiy Books" MCHJ
        </div>
        <div className="mb-2">Ro'yxatdan o'tish raqami</div>
        <div className="mb-2">INN: 305829008</div>
        <div className="mb-2">MCHJ rahbari: Allayev Firuz Abdunasimovich</div>
      </div>
    </div>
  );
}

export default About;
